module.exports = __webpack_public_path__ + "img/logo_meals.54f6c9e6.png";